<script>
  import banner from "../assets/banner.png";
  import paid_promote from "../assets/paid_promote.png";
  import slide1 from "../assets/slide1.png";
  import slide2 from "../assets/slide2.png";
  import slide3 from "../assets/slide3.png";
  import slide4 from "../assets/slide4.png";
  import slide5 from "../assets/slide5.png";
  import playstoreAppDownload from "../assets/play_store_download.png";
  import iosAppDownload from "../assets/black.svg";
</script>

<div class="">
  <!-- Hero Section -->
  <section class="bg-dark p-5 text-light">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-sm-12 col-md-6">
          <img src="/build/assets/{banner}" class="img-fluid" alt="" />
        </div>
        <div class="col-sm-12 col-md-6 mt-sm-3 mt-md-0">
          <h1 class="">Welcome to Kalender Bali</h1>
          <p class="">
            Kalender Bali adalah aplikasi yang dirancang khusus untuk membantu
            pengguna mengakses informasi kalender tradisional Bali dengan mudah
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- About Section -->
  <section class="container">
    <div class="text-center mb-5">
      <img
        src="/build/assets/{paid_promote}"
        class="img-fluid mt-3"
        alt=""
      />
    </div>

    <div class="container">
      <h2 class="text-center">About Kalender Bali</h2>
      <p class="text-center">
        Kalender Bali adalah aplikasi yang dirancang khusus untuk membantu
        pengguna mengakses informasi kalender tradisional Bali dengan mudah.
        Aplikasi ini memberikan berbagai fitur unik yang memungkinkan pengguna
        untuk tetap terhubung dengan tradisi dan budaya Bali, kapan saja dan di
        mana saja.
      </p>

      <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
          <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
          <li data-target="#carouselExampleCaptions" data-slide-to="3"></li>
          <li data-target="#carouselExampleCaptions" data-slide-to="4"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="/build/assets/{slide1}" class="d-block w-100" alt="slider">
          </div>
          <div class="carousel-item">
            <img src="/build/assets/{slide2}" class="d-block w-100" alt="slider">
          </div>
          <div class="carousel-item">
            <img src="/build/assets/{slide3}" class="d-block w-100" alt="slider">
          </div>
          <div class="carousel-item">
            <img src="/build/assets/{slide4}" class="d-block w-100" alt="slider">
          </div>
          <div class="carousel-item">
            <img src="/build/assets/{slide5}" class="d-block w-100" alt="slider">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-target="#carouselExampleCaptions" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-target="#carouselExampleCaptions" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </button>
      </div>

      <h3 class="mt-3">Fitur Utama:</h3>
      <ul class="">
        <li class="">
          <span class="">Kalender Bali Tradisional:</span> Menyediakan informasi
          lengkap mengenai kalender Bali tradisional, termasuk hari-hari baik (hari
          raya, purnama, tilem) dan hari-hari penting lainnya menurut budaya Bali.
        </li>
        <li class="">
          <span class="">Informasi Wuku dan Pawukon:</span> Menampilkan wuku dan
          pawukon yang merupakan sistem penanggalan unik dalam kalender Bali.
        </li>
        <li class="">
          <span class="">Hari Raya dan Upacara:</span> Menginformasikan tentang berbagai
          hari raya dan upacara keagamaan yang dirayakan di Bali, termasuk Nyepi,
          Galungan, Kuningan, dan Saraswati.
        </li>
        <li class="">
          <span class="">Notifikasi Pengingat:</span> Pengguna dapat mengatur notifikasi
          pengingat untuk hari-hari penting dan acara khusus dalam kalender Bali,
          sehingga tidak akan terlewat.
        </li>
        <li class="">
          <span class="">Antarmuka Ramah Pengguna:</span> Desain antarmuka yang intuitif
          dan mudah digunakan membuat pengalaman pengguna menjadi lebih menyenangkan.
        </li>
      </ul>
    </div>
  </section>
  <section class="mb-5">
    <div class="text-center">
      <a
        href="https://apple.co/3Tm4By5"
        alt="download kalender bali ios"
        target="_blank"
      >
        <img
          src="/build/assets/{iosAppDownload}"
          width="150"
          height="150"
          class="img-fluid mt-3"
          alt=""
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.hendrathings.kalenderbali"
        alt="download kalender bali ios"
        target="_blank"
      >
        <img
          src="/build/assets/{playstoreAppDownload}"
          
          width="170"
          class="img-fluid mt-3"
          alt=""
        />
      </a>
    </div>
  </section>
</div>

<style>
  /* Anda bisa menambahkan gaya tambahan jika diperlukan */
</style>
